import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import AgilysysLogo from '../components/AgilysysLogo';
import { CartIcon, HallIcon, ClubIcon, ShopIcon } from '../components/AreaIcons';
import greenTouchIcon from '../assets/green-touch-icon.gif';

const GolfPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page splash2 golfPage">
      <Header />
      <div className="page-header">Golf Course</div>

      <div className="text-blocks">
        <div className="std-text">
          {"Whether you're organizing tournaments, scheduling and tracking tee times, managing the pro shop, directing staff or overseeing player experiences, start with the reliable foundation of Agilysys Golf."}
        </div>
      </div>

      <div className="tap">
        <img
          src={greenTouchIcon}
          alt="Tap to explore"
        />
        <div className="tap-prompt">{"Tap on each section of the map\nTo drill into the details"}</div>
      </div>

      <div className="logo" onClick={() => navigate('/aboutus/agilysys')}>
        <AgilysysLogo />
      </div>

      <div className="golf-map">
        <div className="cart">
          <CartIcon onClick={() => navigate('/golf/cart')} />
        </div>
        <div className="hall">
          <HallIcon onClick={() => navigate('/golf/hall')} />
        </div>
        <div className="club">
          <ClubIcon onClick={() => navigate('/golf/club')} />
        </div>
        <div className="shop">
          <ShopIcon onClick={() => navigate('/golf/shop')} />
        </div>
      </div>
    </div>
  );
};

export default GolfPage;
